// extracted by css-extract-rspack-plugin
export default {"root":"SearchInput_root__vU+9P","input":"SearchInput_input__46Awa","icon-override":"SearchInput_icon-override__3v-T+"};